import { createSlice } from '@reduxjs/toolkit';
import { apiContainer } from '@vlabs/api-bindings';
import { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';
import { permissionValues } from '@vlabs/shared/config/permissions';

import { initApp } from '@vlapps/luna/src/app/store/appSlice';

const store = createSlice({
  name: 'account',
  initialState: {
    isAuthenticated: false,
    model: null,
    data: [],
    meta: {},
  },
  reducers: {
    setAccount(state, { payload }) {
      state.model = payload;
      state.isAuthenticated = true;
    },
    logoutSuccess(state) {
      state.model = null;
      state.isAuthenticated = false;
    },
  },
});

export default store.reducer;

export const {
  setAccount,
  logoutSuccess,
} = store.actions;

export const restoreUserSession = async (dispatch) => {
  try {
    const account = await apiContainer.lunaClient.account.getCurrentSession();

    if (!account) return;
    dispatch(setAccount(account));
    dispatch(initApp);
  } catch (error) {
    if (error instanceof LunaError) {
      if (error.error_code === 11065) {
        return;
      }
      if (error.error.response.status === 401) return;
    }
    throw error;
  }
};

export const login = (credentials) => async (dispatch) => {
  await apiContainer.lunaClient.credentialsVerifier.verify(credentials);

  const streamRules = [
    permissionValues.view,
    permissionValues.creation,
    permissionValues.modification,
    permissionValues.deletion,
  ];

  const { data: { token } } = await apiContainer.lunaClient.tokens.create({
    payload: {
      expiration_time: null,
      permissions: {
        streams: streamRules,
        source: streamRules,
        groups: [permissionValues.view],
      },
    },
    query: {
      grant_all_permissions: 1,
    },
    config: {
      auth: {
        username: credentials.login,
        password: credentials.password,
      },
    },
  });

  await apiContainer.lunaClient.login.login({ token });
  const account = await apiContainer.lunaClient.account.getCurrentSession();

  dispatch(setAccount(account));
  dispatch(initApp);
};

export const logout = async (dispatch) => {
  await apiContainer.lunaClient.ws.disconnect();
  await apiContainer.lunaClient.login.logout();

  dispatch({ type: 'events/setFilters', payload: {} });
  dispatch({ type: 'latestEvents/setParams', payload: {} });
  dispatch({ type: 'matcherSearch/resetSearchState', payload: {} });

  dispatch(logoutSuccess());
  window.history.replaceState({}, '', import.meta.env.PUBLIC_URL);
};
